// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"f92cc7b0","141":"f823f378","178":"bbffb673","219":"481d85d1","220":"16df45ed","427":"d2f2b285","452":"df9ce452","507":"e85c7503","536":"d07cb1f7","551":"977c83cc","574":"95e7ef9b","649":"781f32c7","722":"adcd37dd","842":"a1fac033","873":"ea48b02c"}[chunkId] + ".chunk.js";
};